import { render, staticRenderFns } from "./VxCellPre.vue?vue&type=template&id=4189a754&"
import script from "./VxCellPre.vue?vue&type=script&lang=js&"
export * from "./VxCellPre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports